<div
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  (scrolled)="onScroll()"
  [scrollWindow]="false"
  class="page-container"
>
  <div class="cards-container">
    <div
      *ngFor="let cliente of clientesDoVendedorComLembretes"
      class="cliente-notas-card"
    >
      <div class="card-head">
        <div class="card-left-content">
          <mat-icon>face</mat-icon>

          <div class="texts">
            <div class="label">CLIENTE</div>
            <div class="title" style="font-weight: bold">
              {{ cliente.nome.split(" ").slice(0, 2).join(" ") }}
            </div>
          </div>
        </div>

        <mat-icon
          [routerLink]="['/busca-cliente', cliente.cpf]"
          class="card-right-content"
          style="color: rgb(56, 56, 56)"
          >info</mat-icon
        >
      </div>

      <app-notas-cliente
        [notaType]="'LEMBRETE'"
        [clienteCpf]="cliente.cpf"
        [clienteSiglaMarca]="cliente.sigla_marca"
        (ficouSemLembretes)="deleteCliente(cliente.cpf, cliente.sigla_marca)"
      ></app-notas-cliente>
    </div>
  </div>

  <app-disclaimer
    *ngIf="
      !clientesDoVendedorComLembretes ||
      clientesDoVendedorComLembretes?.length <= 0
    "
    matIconName="search_off"
    message="Você não possui nenhum lembrete pendente dos seus clientes."
  ></app-disclaimer>
</div>
